import { BusinessColId, BusinessColumnDef } from "constants/columnDefinitions";
import {
  ManualAdjustmentColId,
  ManualAdjustmentColumnDef,
} from "constants/columnDefinitions/manualAdjustment";

import { booleanRenderer } from "lib/agGrid/renderers";

/**
 * We are displaying label reversed to what the data columns due to a shift to sundry templates.
 * This may be fixed one day??
 */

const fromBusinessColDef = {
  ...BusinessColumnDef[BusinessColId.NAME],
  colId: ManualAdjustmentColId.FROM_BUSINESS,
  field: "fromBusiness.name",
  headerName: "Paid To Business",
  cellRendererParams: {
    businessKey: "manualAdjustment.fromBusinessId",
  },
};

const emailAttachmentsToFromBusinessColDef = {
  colId: ManualAdjustmentColId.EMAIL_ATTACHMENTS_TO_FROM_BUSINESS,
  cellRenderer: booleanRenderer,
  field: "manualAdjustment.emailAttachmentsToFromBusiness",
  headerName: "Send Files to Paid To Business",
  width: 240,
  hideOnMobile: true,
};

const toBusinessColDef = {
  ...BusinessColumnDef[BusinessColId.NAME],
  colId: ManualAdjustmentColId.TO_BUSINESS,
  field: "toBusiness.name",
  headerName: "Paid From Business",
  cellRendererParams: {
    businessKey: "manualAdjustment.toBusinessId",
  },
};

const emailAttachmentsToToBusinessColDef = {
  cellRenderer: booleanRenderer,
  colId: ManualAdjustmentColId.EMAIL_ATTACHMENTS_TO_TO_BUSINESS,
  field: "manualAdjustment.emailAttachmentsToToBusiness",
  headerName: "Send Files to Paid From Business",
  width: 240,
  hideOnMobile: true,
};

export const columnDefs = [
  ...Object.values(ManualAdjustmentColumnDef),
  fromBusinessColDef,
  emailAttachmentsToFromBusinessColDef,
  toBusinessColDef,
  emailAttachmentsToToBusinessColDef,
];

export const mobileColumnDefs = [
  ManualAdjustmentColumnDef[ManualAdjustmentColId.NOTE],
  ManualAdjustmentColumnDef[ManualAdjustmentColId.SUBTOTAL_CENTS],
  ManualAdjustmentColumnDef[ManualAdjustmentColId.GST_CENTS],
  ManualAdjustmentColumnDef[ManualAdjustmentColId.TOTAL_CENTS],
  // flexOnMobile from BusinessColumnDef.NAME causes flex: 1, which ag-grid
  // honours over autoSizeAllColumns. Disable it so autosize sizes the column
  // to actual business-name content on mobile.
  { ...toBusinessColDef, flexOnMobile: false },
  { ...fromBusinessColDef, flexOnMobile: false },
  ManualAdjustmentColumnDef[ManualAdjustmentColId.ACTIONS],
];
